import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { useTranslation } from "react-i18next";

export default function Login() {
  const { login, formatApiError } = useAuth();
  const nav = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success(t("nav.signIn") + " ✓");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-black text-white grain">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="text-xs uppercase tracking-[0.3em] text-[#e65f2b]">{t("nav.signIn")}</div>
        <h1 className="mt-2 font-display text-4xl font-bold uppercase tracking-tight">{t("auth.signInTitle")}</h1>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label htmlFor="email" className="uppercase text-xs tracking-widest text-white/70">{t("auth.email")}</Label>
            <Input
              id="email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email-input"
              className="mt-2 bg-transparent border-white/20 rounded-sm h-11 focus:border-[#e65f2b]"
            />
          </div>
          <div>
            <Label htmlFor="password" className="uppercase text-xs tracking-widest text-white/70">{t("auth.password")}</Label>
            <Input
              id="password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password-input"
              className="mt-2 bg-transparent border-white/20 rounded-sm h-11 focus:border-[#e65f2b]"
            />
          </div>
          <Button
            type="submit" disabled={loading}
            data-testid="login-submit-btn"
            className="w-full bg-[#e65f2b] hover:bg-[#c54a1c] text-black font-bold uppercase tracking-widest rounded-sm h-11"
          >
            {loading ? t("auth.signInLoading") : t("auth.signIn")}
          </Button>
        </form>
        <p className="mt-6 text-sm text-white/60">
          {t("auth.noAccount")}{" "}
          <Link to="/register" className="text-[#e65f2b] hover:underline">{t("auth.createAccount")}</Link>
        </p>
        <p className="mt-2 text-sm text-white/60">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="text-white/70 hover:text-[#e65f2b] hover:underline">{t("auth.forgotPassword")}</Link>
        </p>
      </div>
    </div>
  );
}
